import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'65665565665',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
